import {LayerImageRepository} from './LayerImageRepository';
import { BenchBackRestLightLayer } from './Layers/BenchBackRestLightLayer';
import { BencBasseLayer } from './Layers/BenchLayer';
import { DoorWallLayer } from './Layers/DoorWallLayer';

import { FloorLayer } from './Layers/FloorLayer';
import { Layer } from './Layers/Layer';
import {PanelLayer} from './Layers/PanelLayer';
import { StoveLayer } from './Layers/StoveLayer';
import ImageResolution from './saunaparts/ImageResolution';
import {Sauna} from './saunaparts/Sauna';


export class SaunaImageRenderer {
    imageRepository: LayerImageRepository;
    constructor(imageRepository: LayerImageRepository) {
        this.imageRepository = imageRepository;
    }
    async Render(sauna: Sauna, desiredResolution: ImageResolution): Promise<CanvasImageSource> {
   
        let baseLayer: Layer;        
        baseLayer = new FloorLayer(sauna.Size, this.imageRepository);
        let baseIamge = document.createElement("canvas");
        baseIamge.width = desiredResolution.width;
        baseIamge.height = desiredResolution.height;
        let context = baseIamge.getContext("2d");

        return baseLayer.Render(desiredResolution).
            then((floor) => {
                context?.drawImage(floor, 0, 0, desiredResolution.width, desiredResolution.height);
            return new  PanelLayer(sauna.PanelMaterial, sauna.Size, this.imageRepository).Render(desiredResolution);
        }).        
        then((panel)=>{      
            return new BenchBackRestLightLayer(sauna.Model,sauna.backrestLightType,this.imageRepository,panel).Render(desiredResolution);
        }).then((light)=>{
            context?.drawImage(light, 0, 0, desiredResolution.width, desiredResolution.height);
            if (sauna.Model)
                return new BencBasseLayer(sauna, this.imageRepository, context!!).Render(desiredResolution);
            else
                return context;
        }).then(() => {
            if (sauna.stove) {
                return new StoveLayer(this.imageRepository, sauna).Render(desiredResolution).then(stove => { context?.drawImage(stove, 0, 0, desiredResolution.width, desiredResolution.height); return context; });
            }
            else
                return context;
        })  
        .then(()=>{    
           
            if (sauna.renderFrontWall)
                return new DoorWallLayer(this.imageRepository, sauna).Render(desiredResolution);
            else {
                return baseIamge;
            }
        }).then((door) => {
            context?.drawImage(door,0,0,desiredResolution.width,desiredResolution.height);
            return baseIamge     
        });
    
    }
}